module.exports = __webpack_public_path__ + "static/img/SearchDetailCredit4.53dfe9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailCredit4.png
// module id = 715
// module chunks = 0